var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-page',{attrs:{"show-loading-page":_vm.showLoadingPage,"loading-message":_vm.loadingMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }